import { inject } from "@angular/core";
import { CanMatchFn, Route, Router, UrlSegment } from "@angular/router";

export const languageRedirectGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const router = inject(Router);
  const supportedLangs = ["nl", "fr"];

  // If no segments, or first segment isn't a language code
  if (segments.length === 0 || !supportedLangs.includes(segments[0].path)) {
    // Build the new URL, prefixed with /nl
    const fullPath = segments.map((s) => s.path).join("/");
    router.navigateByUrl(`/nl/${fullPath}`);
    return false;
  }

  // Language is fine, continue navigation
  return true;
};
